import { doRequest } from '@r1-frontend/do-request';
import {
    availability,
    EAvailability,
    IAvailability,
} from '@r1-frontend/api-domru/api-loyalty/v1/program/availability';
import { IInfo, info } from '@r1-frontend/api-domru/api-loyalty/v1/program/info';

import { TDispatch, TGetState } from '~/src/store';
import { setLoyaltyAvailability, setLoyaltyInfo } from '~/src/store/actionCreators/loyalty';
import selectProviderId from '~/src/store/selectors/selectProviderId';

export function getLoyaltyAvailability() {
    return async(dispatch: TDispatch, getState: TGetState): Promise<void> => {
        const state = getState();
        const providerId = selectProviderId(state);
        const plAvailable = state.city.currentCity.plAvailable;

        if (plAvailable) {
            const resp = await doRequest.apiLoyalty<IAvailability>(
                availability(providerId),
            );

            if (resp.isSuccess) {
                const { available } = resp.payload;
                const isRegistered = available === EAvailability.REGISTRED;

                dispatch(setLoyaltyAvailability({
                    available,
                    isAvailable: available === EAvailability.AVAILABLE,
                    isRegistered,
                }));

                if (isRegistered) {
                    await getLoyaltyInfo()(dispatch, getState);
                }
            }
        }
    };
}

export function getLoyaltyInfo() {
    return async(dispatch: TDispatch, getState: TGetState): Promise<void> => {
        const state = getState();
        const providerId = selectProviderId(state);

        const resp = await doRequest.apiLoyalty<IInfo>(
            info(providerId),
        );

        if (resp.isSuccess) {
            dispatch(setLoyaltyInfo(resp.payload));
        }
    };
}
